import { useEffect, useMemo, useState } from "react";

const STATE_STYLES = {
  LIVE: "border-[#BBF7D0] bg-[#DCFCE7] text-[#166534]",
  ENDING_SOON: "border-[#FDE68A] bg-[#FEF3C7] text-[#92400E]",
  CLOSING_SOON: "border-[#FECACA] bg-[#FEE2E2] text-[#991B1B]",
  CLOSED: "border-slate-200 bg-slate-100 text-slate-500",
};
const STATE_LABELS = { LIVE: "LIVE", ENDING_SOON: "ENDING SOON", CLOSING_SOON: "CLOSING SOON", CLOSED: "TIME EXPIRED" };

export default function EventCountdown({ deadline, serverTime, label = "Time Remaining", testid = "event-countdown" }) {
  // Sync to server time once per serverTime change; tick locally every second. Never shows negative time.
  const offset = useMemo(() => (serverTime ? new Date(serverTime).getTime() - Date.now() : 0), [serverTime]);
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const rem = Math.max(0, Math.floor((new Date(deadline).getTime() - (now + offset)) / 1000));
  const d = Math.floor(rem / 86400), h = Math.floor((rem % 86400) / 3600), m = Math.floor((rem % 3600) / 60), s = rem % 60;
  let state = "LIVE";
  if (rem <= 0) state = "CLOSED";
  else if (rem < 3600) state = "CLOSING_SOON";
  else if (rem < 86400) state = "ENDING_SOON";
  const pad = (n) => String(n).padStart(2, "0");
  return (
    <div data-testid={testid}>
      <p className="text-xs uppercase tracking-wide text-muted-foreground">{label}</p>
      <div className="mt-1 flex flex-wrap items-center gap-2">
        <span data-testid={`${testid}-state`} className={`rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STATE_STYLES[state]}`}>
          {STATE_LABELS[state]}
        </span>
        <span className="font-mono text-sm font-semibold tabular-nums" data-testid={`${testid}-value`}>
          {state === "CLOSED" ? "00d 00h 00m 00s" : `${pad(d)}d : ${pad(h)}h : ${pad(m)}m : ${pad(s)}s`}
        </span>
      </div>
    </div>
  );
}
